<template lang="pug">
  sw-modal.max-w
    .btn.btn-blue.btn-xs.ml-2(data-purpose="add_civil_liability_button") {{ $t('shared.theOperatorDrawer.addCivilLiability') }}
    div(slot="modal-content").p-10
      .text-lg.-mt-8.mb-4 {{ $t('shared.theOperatorDrawer.addCivilLiability') }}
      sw-select.max-w(
        v-model="insurer"
        :options="insurers"
        :placeholder="$t('shared.theOperatorDrawer.insurer')"
        custom-classes="block rounded border border-green-900 p-3 focus:outline-none"
        data-purpose="civil_liability_insurer_select"
        dropdown-classes="w-full text-left z-5 bg-gray-100 shadow-lg rounded border border-green-900 md:my-2"
      )
      sw-select.max-w.py-5(
        v-model="coverage"
        :options="coverages"
        :placeholder="$t('shared.theOperatorDrawer.civilLiabilityCoverage')"
        custom-classes="block rounded border border-green-900 p-3 focus:outline-none"
        data-purpose="civil_liability_coverage_select"
        dropdown-classes="w-full text-left z-5 bg-gray-100 shadow-lg rounded border border-green-900 md:my-2"
      )
      span.flex.items-center.mb-4(v-if="message" class="text-red-500")
        sw-icon(
          name="close"
          size="w-4 h-4"
        )
        .text-xs.ml-1 {{ message }}
      button.btn.btn-blue.btn-sm(
        class="focus:outline-none"
        data-purpose="civil_liability_submit_button"
        @click="handleSubmit"
      ) {{ $t('shared.theOperatorDrawer.submitCivilLiability') }}

</template>

<script>
import axios from 'axios';
import SwModal from '../generic/SwModal';
import SwSelect from '../generic/SwSelect';

export default {
  name: 'TheCivilLiabilityForm',
  components: {
    SwModal,
    SwSelect,
  },
  props: {
    insurers: {
      type: Array,
      default: null,
    },
    coverages: {
      type: Array,
      default: null,
    },
  },
  data: function () {
    return {
      show: false,
      insurer: null,
      coverage: null,
      message: null,
    };
  },
  methods: {
    handleSubmit () {
      axios.post('/back_office/user/add_civil_liability_to_full_package_bundle', { insurer_slug: this.insurer, coverage: this.coverage })
      .then(({ data }) => {
        if (data.success) location.reload();
      })
      .catch(({ response }) => {
        this.message = response.data.message;
      });
    },
  },
};
</script>
